import type { ListDivisionsV2CommandInput } from '@amzn/gbsa-orbit-typescript-client';

export const v2DivisionKeys = {
  all: ['v2', 'divisions'] as const,
  lists: () => [...v2DivisionKeys.all, 'list'] as const,
  list: (filters: Partial<ListDivisionsV2CommandInput>) =>
    [...v2DivisionKeys.lists(), filters] as const,
};
